import { getBrandFromHost } from "@theme/config";

export const convertDomainToCorrespondingBrand = () => {
  const host = window.location.hostname.toLowerCase();
  const brand = getBrandFromHost(host);

  switch (brand) {
    case "fgfParent":
      return "Fgf";
    case "nimbleParent":
      return "Nimble";
    case "defaultFallback":
      return "Fgf";
    default:
      return "Fgf";
  }
};
